// extracted by mini-css-extract-plugin
export default {"pivotButton":"PivotButton_pivotButton__OC3lT"};